/**
 * engineerStyles.js - the status colour rule and inline styles shared by the
 * engineers list and the engineer detail panel.
 */

export const headerBg = (status) => {
  if (status === 'PTO') return '#616161';
  if (status === 'Office') return '#1A237E';
  return '#1B5E20';
};

export const BTN_PRIMARY = {
  background: '#1B5E20',
  color: '#fff',
  border: 'none',
  padding: '9px 20px',
  borderRadius: 6,
  fontWeight: 700,
  fontSize: 11,
  cursor: 'pointer',
  fontFamily: 'Montserrat',
};
